import React from "react";
import { Navigate } from "react-router-dom";
import { auth } from "../firebase";
import { useAuthState } from "react-firebase-hooks/auth";

const ProtectedRoute = ({ children }) => {
  const [user, loading] = useAuthState(auth);

  if (loading) {
    return <p>Loading...</p>;
  }

  if (!user) {
    // Redirect to login if not authenticated
    return <Navigate to="/v1/login" replace />;
  }

  // Show protected content if logged in
  return children;
};

export default ProtectedRoute;
